import { Column } from 'primereact/column';
import { DataTableRowClickEvent } from 'primereact/datatable';
import { useNavigate } from 'react-router-dom';
import { PaginatedDataTable } from '../../../components/PaginatedDataTable';
import { BaseChip } from '../../../components/Chips';
import { ButtonEdit, ButtonDelete } from '../../../components/Buttons';
import type { LanguageResponse } from '../../../../api';

export interface LanguageTableProps {
    languages: LanguageResponse[] | null;
    loading: boolean;
    onClickEditLanguage: (language: LanguageResponse) => void;
    onClickDeleteLanguage: (language: LanguageResponse) => void;
    disabled: boolean;
}

export const LanguageTable: React.FC<LanguageTableProps> = ({
    languages,
    loading,
    onClickEditLanguage,
    onClickDeleteLanguage,
    disabled 
}) => {
    const navigate = useNavigate();

    const activeTemplate = (rowData: LanguageResponse) => {
        return <BaseChip
            label={rowData.active ? 'Aktivní' : 'Neaktivní'}
            severity={rowData.active ? 'success' : 'danger'}
        />;
    };
    const buttonsTemplate = (rowData: LanguageResponse) => {
        return (
            <div className="table-buttons">
                <ButtonEdit
                    title="Upravit jazyk"
                    rounded
                    disabled={disabled}
                    onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                        e.stopPropagation();
                        onClickEditLanguage(rowData);
                    }}
                />

                <ButtonDelete
                    title="Smazat jazyk"
                    rounded
                    disabled={disabled}
                    onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                        e.stopPropagation();
                        onClickDeleteLanguage(rowData);
                    }}
                />
            </div>
        );
    };

    return (
        <PaginatedDataTable
            value={languages}
            loading={loading}
            removableSort
            breakpoint='500px'
            emptyMessage='Nebyly nalezeny žádné jazyky'
            onRowClick={(event: DataTableRowClickEvent) =>
                navigate(`/admin/jazyk/${event.data.language_code}/enums`)
            }
            rowClassName={'table-row--clickable'}
            rowHover
        >
            <Column field='language_code' header='Kód' />
            <Column field='en_name' header='Anglický název' sortable />
            <Column field='local_name' header='Lokální název' sortable />
            <Column header='Aktivita' body={activeTemplate} align='center' />
            <Column body={buttonsTemplate} align='right' />
        </PaginatedDataTable>
    );
};
